module.exports = __webpack_public_path__ + "img/AMD_6613_thumb.403d301e.jpg";